































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Airport from "@/store/entities/flight/airport";
import Agency from "@/store/entities/agency";
import moment from "moment";
import FlightPassenger from "@/store/entities/flight/flightPassengerList";
import ajax from "@/lib/ajax";
import CustomTable from "@/components/customTable.vue";
import SendMailToCustomerModalVue from "./modals/sendMailToCustomerModal.vue";
const ExcelJS = require('exceljs');
@Component({
  components: {
    CustomTable,
    SendMailToCustomerModalVue
  },
})
export default class FlightPassengerList extends Vue {
  
  mockData: any[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  active_tab: number = 0;
  checkbox: boolean = false;
  isOpenRow: boolean = false;
  radios: boolean = true;
  flightPassenger: FlightPassenger[] = [];
  filterPassengerList: FlightPassenger[] = [];
  startDate: Date = null;
  startDateMenu: boolean = false;
  endDate: Date = null;
  endDateMenu: boolean = false;
  airports: Airport[] = [];
  fromAirport: Airport = new Airport();
  toAirport: Airport = new Airport();
  agencies: Agency[] = [];
  agency:Agency=new Agency();
  customerName: string = "";
  flightNo: string = "";
  pnr: string="";
  sendMailModal: boolean = false;
  checkedPassenger: any[] = [];
  totalPax:number=0;
  customerSurname:string="";
  searchKey:string="";
  selectedCount:number=0;
  closeDialog(e) {
    this.sendMailModal = false;
    this.$emit("closed");
  }
  passengers(e){
    debugger;
    this.selectedCount=e;
  }
  list(e) {}
  get excel_fields (){
    // regular field (exported data 'as is')
  
     return  {
        "name":"flightNo",
        
        "pnr" : {
                field: 'flightOrders',
                callback: (value) => {
                  for (let index = 0; index < value.length; index++) {
                    return ` ${value[index].orderNo}`;
                    
                  }
                }
     }
    }
   
}

  clearForm(){
    this.pnr="";
    this.customerName="";
    this.customerSurname="";
    this.flightNo="";
    this.agency=null;
    this.startDate=null;
    this.endDate=null;
  }

  async updateConfirmation(){
    var passengerList = this.flightPassenger.map(passenger => ({ ...passenger }));
     var passengerIds: any[]=[];
     console.log(passengerList);
    for (let index = 0; index < passengerList.length; index++) {
      passengerList[index].flightOrders.forEach(element => {
     
        let passengerObject = {id:element.id,isChecked:element.isChecked}
        passengerIds.push(passengerObject)
    })


    }
   
    const response = await ajax.put(
      "/api/services/app/admin/UpdatePassengerConfirmations",
      passengerIds
    );
    Vue.$toast.open({
            message: "Liste Kaydedildi.",
            type: "success",
          });
  }
async tableToExcel(){

  // Excel çalışma kitabı oluşturun
  const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('My Sheet');
  
    var passengerList = this.flightPassenger.map(passenger => ({ ...passenger })).reverse();
    passengerList.forEach(element => {
       element.flightOrders  = element.flightOrders.filter(y=>y.isChecked).sort((a, b) => a.orderNo - b.orderNo); 
    });

  console.log(passengerList)
  for (let index = 0; index < passengerList.length; index++) {


    if(passengerList[index].flightOrders.length>0){
      let flightInfo=passengerList[index];
      var rowValues = [];
    rowValues[1] = flightInfo.route + " "  + flightInfo.flightNo + " " + moment(String(flightInfo.departureDate)).format('DD-MM-YYYY')  + " " + moment(String(flightInfo.departureDate)).format('HH:mm');;
   
    worksheet.insertRow(1,rowValues);
    passengerList[index].flightOrders.forEach(element => {
     // Insert a row by sparse Array (assign to columns A, E & I)
var rowValues = [];
rowValues[2] = element.orderNo;

rowValues[3] = flightInfo.route;
rowValues[4] = flightInfo.flightNo;
rowValues[5] = element.agency.name;
rowValues[6] = flightInfo.operatorCode;
rowValues[7] = element.surname;
rowValues[8] = element.name;

     worksheet.insertRow(2,rowValues);
        
          });
         
    }

      
    

  }
    
    

    // Excel dosyasını yazdırın ve bir Buffer alın
    const buffer = await workbook.xlsx.writeBuffer();

    // Buffer'ı Blob'a dönüştürün
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // Excel dosyasını indirme bağlantısını oluşturun
    const url = window.URL.createObjectURL(blob);

    // Excel dosyasını indirme bağlantısını açın
    const a = document.createElement('a');
    a.href = url;
    a.download = 'data.xlsx';
    a.click();
}
  
  
  sendEmailInfo() {
    this.sendMailModal = true;
  }
  get getEndDate() {
    return this.endDate ? moment(this.endDate).format("DD-MM-yyyy") : "";
  }
  get getStartDate() {
    return this.startDate ? moment(this.startDate).format("DD-MM-yyyy") : "";
  }

  created() {
 
    this.getAgency();
    this.getAirports();
    (this.headers = [
      { text: "PNR", value: "pnr" },
      { text: "Güzergah", value: "destination" },
      { text: "Uçuş Numarası", value: "flightNumber" },
      { text: "Acente", value: "agency" },
      { text: "Operatör", value: "operator" },
      { text: "Operatör PNR", value: "operatorPnr" },
      { text: "Soyadı", value: "surname" },
      { text: "İsim", value: "name" },
      { text: "Cinsiyet", value: "gender" },
    ]),
      (this.breadcrumbsItems = [
        { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
        { text: "Uçuş", disabled: true },
        { text: "Uçuş Yolcu Listesi", disabled: true },
      ]);
  }
  async searchPassengers() {
    if(this.agency==null || this.agency==undefined){
      let agency = new Agency(); 
      this.agency=agency;
    }
    this.flightPassenger= [];
    this.totalPax=0;
    const payload = {
      customerName: this.customerName,
      customerSurname: this.customerSurname,
      flightNo:this.flightNo,
      agencyId:this.agency.id,
      orderNo:this.pnr,
      starts: moment(this.startDate).format("MM-DD-yyyy"),
      ends: moment(this.endDate).format("MM-DD-yyyy"),
    };
    const response = await ajax.get(
      "/api/services/app/booking/GetFlightPassengers",
      { params: { ...payload } }
    );
    const data = response.data.result.items;
    data.forEach(x => {
      x.flightOrders.forEach(y => {
           y.passengers.forEach(element => {
              this.totalPax+=element.passengers.length;
           });
            });
        });
    
    const result = this.groupBy(data, "flightNo");
   
for (const index in result) {
  for (let orderDataIndex in result[index]) {
    var flightOrderPassenger: FlightPassenger = new FlightPassenger();
    flightOrderPassenger.flightOrders = [];
    flightOrderPassenger.flightNo = result[index][orderDataIndex].flightNo;
    flightOrderPassenger.flightNo = result[index][orderDataIndex].flightNo;
    flightOrderPassenger.operatorCode = result[index][orderDataIndex].operatorCode;
    flightOrderPassenger.departureDate = result[index][orderDataIndex].departureDate;
    var orders = result[index][orderDataIndex].flightOrders;
    const flightOrders = this.groupBy(orders, "pnr");
    for (let orderIndex in flightOrders) {
      var orderFlightPassenger: FlightPassenger = new FlightPassenger();
      orderFlightPassenger.flightOrders = [];
      orderFlightPassenger.flightNo = result[index][orderDataIndex].flightNo;
      flightOrderPassenger.route = result[index][orderDataIndex].route;
      orderFlightPassenger.operatorCode = result[index][orderDataIndex].operatorCode;
      orderFlightPassenger.departureDate = result[index][orderDataIndex].departureDate;
      orderFlightPassenger.route = flightOrders[orderIndex][0].route;
      for (let dataIndex in flightOrders[orderIndex]) {
        for (let passengerIndex in flightOrders[orderIndex][dataIndex].passengers) {
          var passengerData = flightOrders[orderIndex][dataIndex].passengers[passengerIndex];
          var passenger = Object.assign({}, passengerData.passengers[0]);
          passenger.agency = flightOrders[orderIndex][dataIndex].agency;
          passenger.operator = passengerData.flightProviderQuota;
          passenger.orderId = flightOrders[orderIndex][dataIndex].orderId;
          passenger.orderNo = flightOrders[orderIndex][dataIndex].order.orderNo;
          passenger.flightOrderId = flightOrders[orderIndex][dataIndex].id;
          
          passenger.passengerStatus=flightOrders[orderIndex][dataIndex].passengers[passengerIndex].passengerStatus;
          
          orderFlightPassenger.flightOrders.push(passenger);
        }
      }
      flightOrderPassenger.flightOrders.push(...orderFlightPassenger.flightOrders);
    }

    this.flightPassenger.push(flightOrderPassenger);

  
}
 
  
}

  }
  groupBy = (items, key) =>
    items.reduce(
      (result, item) => ({
        ...result,
        [item[key]]: [...(result[item[key]] || []), item],
      }),
      {}
    );
  async getAirports() {
    await this.$store.dispatch({
      type: "airport/getAirports",
      data: "{}",
    });
    this.airports = this.$store.state.airport.list;
  }
  @Watch("searchKey")
  filterPassengers() {
    if(this.filterPassengerList.length==0){
      this.filterPassengerList=this.flightPassenger;
   // let filterResults=this.flightPassenger.filter(x=>x.flightNo.includes(this.searchKey.toUpperCase()) || x.route.includes(this.searchKey.toUpperCase()));
   let filterResults=this.flightPassenger.filter(x=>x.flightNo.includes(this.searchKey.toUpperCase()) || x.operatorCode.includes(this.searchKey.toUpperCase())  || x.route.includes(this.searchKey.toUpperCase()) || x.flightOrders.some(y=>y.fullName.toLocaleLowerCase().includes(this.searchKey) || y.fullName.toUpperCase().includes(this.searchKey)  || y.agency.name.toUpperCase().includes(this.searchKey)  || y.agency.name.toLocaleLowerCase().includes(this.searchKey)));
    
   
   this.flightPassenger= filterResults;
    }
    else{
      this.flightPassenger=this.filterPassengerList;
      let filterResults=this.flightPassenger.filter(x=>x.flightNo.includes(this.searchKey.toUpperCase()) || x.operatorCode.includes(this.searchKey.toUpperCase()) || x.route.includes(this.searchKey.toUpperCase()) || x.flightOrders.some(y=>y.fullName.toLocaleLowerCase().includes(this.searchKey)  || y.fullName.toUpperCase().includes(this.searchKey )|| y.agency.name.toUpperCase().includes(this.searchKey)  || y.agency.name.toLocaleLowerCase().includes(this.searchKey)));
    this.flightPassenger= filterResults;
    }
 
   
    
  }
  async getAgency() {
    await this.$store.dispatch({
      type: "agency/getAgency",
    });
    this.agencies = this.$store.state.agency.list;
  }
}
